import React from "react";

import styles from "./Section8.module.scss";

export const Section8 = function () {
  return (
    <section id="conveners-section" className={`${styles.section6Wrapper} cc--component-container`}>
      <h3>MIT FACULTY</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Dimitris Bertsimas</p>
            <p>
              Professor of Management, Boeing Leaders for Global Operations and
              Associate Dean for the Master of Business Analytics, MIT
            </p>
          </div>
        </div>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Tommi Jaakkola</p>
            <p>
              Thomas Siebel Professor of Electrical Engineering and Computer Science,
              and the Institute for Data, Systems, and Society, MIT
            </p>
          </div>
        </div>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Dina Katabi</p>
            <p>
              Andrew and Erna Viterbi Professor of Electrical Engineering and Computer Science at MIT,
              and the leader of NETMIT research group at CSAIL
            </p>
          </div>
        </div>
      </div>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>David Sontag</p>
            <p>
              Associate Professor of Electrical Engineering and Computer Science, MIT
            </p>
          </div>
        </div>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Collin Stultz</p>
            <p>
              Professor of Electrical Engineering and Computer Science,
              Institute for Medical Engineering and Science at MIT
            </p>
          </div>
        </div>
      </div>
      <h3 className={styles.expertsContainer}>INDUSTRY EXPERTS</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Kevin Hughes</p>
            <p>
              MD, Co-Director at Avon Comprehensive Breast Evaluation Center,
              and Medical Director at Bermuda Cancer Genetics and Risk Assessment Clinic
            </p>
          </div>
        </div>
        <div className={styles.section6Content}>
          <div className={styles.name}>
            <p>Constance Lehman</p>
            <p>
              MD and Professor of Radiology,<br />
              Harvard Medical School
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
